import { environment, ENVIRONMENT } from "@/lib/environment";
import { envVars } from "@/lib/envVars";

const ENVIRONMENT_TO_MATOMO_URL: Record<ENVIRONMENT, string | undefined> = {
  development: envVars.VITE_MATOMO_URL_DEV,
  test: envVars.VITE_MATOMO_URL_TEST,
  staging: envVars.VITE_MATOMO_URL_STAGING,
  production: envVars.VITE_MATOMO_URL_PROD,
};

const ENVIRONMENT_TO_MATOMO_SITE_ID: Record<ENVIRONMENT, string | undefined> = {
  development: envVars.VITE_MATOMO_SITE_ID_DEV,
  test: envVars.VITE_MATOMO_SITE_ID_TEST,
  staging: envVars.VITE_MATOMO_SITE_ID_STAGING,
  production: envVars.VITE_MATOMO_SITE_ID_PROD,
};

export const getMatomoUrl = () => {
  return ENVIRONMENT_TO_MATOMO_URL[environment] ?? "https://matomo.roqua.nl";
};

export const getMatomoSiteId = () => {
  return ENVIRONMENT_TO_MATOMO_SITE_ID[environment] ?? "1";
};
